/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Override PDF label language. When omitted or null, defaults to the locale language, then entity locale.
 * @nullable
 */
export type PdfExportByDateRangeLanguage = typeof PdfExportByDateRangeLanguage[keyof typeof PdfExportByDateRangeLanguage] | null;


export const PdfExportByDateRangeLanguage = {
  en: 'en',
  de: 'de',
  sl: 'sl',
  it: 'it',
  fr: 'fr',
  es: 'es',
  pt: 'pt',
  nl: 'nl',
  pl: 'pl',
  hr: 'hr',
  sv: 'sv',
  fi: 'fi',
  et: 'et',
  bg: 'bg',
  cs: 'cs',
  sk: 'sk',
  nb: 'nb',
  is: 'is',
} as const;
